import * as React from "react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Home, Search, ContactMail } from "@mui/icons-material";
import PersonSearchSharpIcon from "@mui/icons-material/PersonSearchSharp";
import PeopleAltSharpIcon from "@mui/icons-material/PeopleAltSharp";
import Groups2Icon from "@mui/icons-material/Groups2";
import LoginIcon from "@mui/icons-material/Login";
import { useUser } from "../../context/UserContext";
import "./ProfileModal.css";
import Logout from "./Logout ";
import About from "../pages/about/About";
import axios from "axios";

const drawerWidth = 240;
const routeMap = {
  // Home: "/",
  About: "topfaculty-about-us",
  Student: "/studentregister",
  SearchTeacher: "/myteacherlist",
  Teacher: "/facultyregister",
  Contact: "/contact-us",
  Counsellors: "https://vgigroup.co.in/counseller.php",
};

//buttons
const navItems = [
  // "Home",
  "About",
  "SearchTeacher",
  "Student",
  "Teacher",
  "Contact",
  "Counsellors",
];
//icons
const iconMap = {
  // Home: Home,
  About: Groups2Icon,
  SearchTeacher: Search,
  Student: PersonSearchSharpIcon,
  Teacher: LoginIcon,
  Contact: ContactMail,
  Counsellors: PeopleAltSharpIcon,
};

function Header(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography
        variant="h6"
        sx={{
          my: 1,
          display: "flex",
          // backgroundColor: "#002147",
          justifyContent: "center", // Centers horizontally
          alignItems: "center", // Ensures vertical alignment
        }}
      >
        <Link
          className="mx-3"
          to={`/`}
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            fontWeight: "700",
          }}
        >
          <img
            src="assetsfront/images/tlogo.png"
            style={{
              width: "30%",
              background: "white",
              borderRadius: "197px",
            }}
            alt="Footer Logo"
          />{" "}
          TOPFACULTY
        </Link>
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton
              component={Link}
              to={routeMap[item]}
              sx={{
                textAlign: "left",
                backgroundColor: "#182878",
                color: "white",
                "&:hover": { backgroundColor: "primary.dark" },
              }}
            >
              {iconMap[item] &&
                React.createElement(iconMap[item], {
                  sx: { fontSize: 23, marginRight: 1 },
                })}
              <ListItemText
                primary={item}
                primaryTypographyProps={{ fontWeight: 700 }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;
  const { user } = useUser();

  const [showProfileModal, setShowProfileModal] = useState(false);
  // console.log(user);
  // console.log(user.user_name);

  // STUDENT PROFILE
  const [studentData, setStudentData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.user_id) return;

    axios
      .get("https://topfaculty.co.in/api/student_list.php", {
        params: { StudentId: user.user_id },
      })
      .then((response) => {
        console.log("studentlist:", response.data);

        const data = Array.isArray(response.data)
          ? response.data
          : [response.data];
        setStudentData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching student data:", error);
        setLoading(false);
      });
  }, [user]);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar component="nav" sx={{ backgroundColor: "#002147" }}>
        <Toolbar>
          <Typography
            variant="h6"
            sx={{
              my: 1,
              display: "flex",
              // backgroundColor: "#002147",
              justifyContent: "center", // Centers horizontally
              alignItems: "center", // Ensures vertical alignment
            }}
          >
            {/* Mobile View Nav */}
            <Box sx={{ display: { xs: "flex", md: "none" } }}>
              {" "}
              <Link
                to={`/`}
                style={{
                  display: "flex",
                  color: "white",
                  alignItems: "center",
                  textDecoration: "none",
                  fontWeight: "700",
                }}
              >
                <img
                  src="assetsfront/images/tlogo.png"
                  style={{
                    width: "22%",
                    background: "white",
                    borderRadius: "197px",
                  }}
                  alt="Footer Logo"
                />
                &nbsp; TOPFACULTY
                {/* Login Profile */}
                {/* <div className="user-info">
                  {user ? (
                    <>
                      <div className="container py-2 ">
                        <div className="row">
                          <div className="col-lg-12 col-md-12 col-12">
                            <ul className="list-unstyled">
                              <li className="dropdown ml-2">
                                <a
                                  className="rounded-circle "
                                  href="#"
                                  role="button"
                                  id="dropdownUser"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  <div className="avatar avatar-md avatar-indicators avatar-online">
                                    <img
                                      alt="avatar"
                                      src="https://cdn-icons-png.flaticon.com/128/1999/1999625.png"
                                      className="rounded-circle"
                                    />
                                  </div>
                                </a>
                                <div
                                  className="dropdown-menu pb-2"
                                  aria-labelledby="dropdownUser"
                                  style={{ marginLeft: "-164px" }}
                                >
                                  <div className="dropdown-item">
                                    <div className="d-flex py-2">
                                      <div className="avatar avatar-md ">
                                        <img
                                          alt="avatar"
                                          src="https://cdn-icons-png.flaticon.com/128/1999/1999625.png"
                                          className="rounded-circle"
                                        />
                                      </div>
                                      <div className="ml-3 lh-1">
                                        <h5 className="mb-0">
                                          {" "}
                                          <strong>
                                            Welcome, {user.user_name}
                                          </strong>
                                        </h5>
                                        <p className="mb-0">
                                          {user.user_email}
                                        </p>
                                        <hr />
                                        <br></br>
                                        <h5 className=" mb-0">
                                          {" "}
                                          <strong>
                                            <ExitToAppSharpIcon /> <Logout />
                                          </strong>
                                        </h5>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <span> </span>
                  )}
                </div> */}
              </Link>
            </Box>
          </Typography>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
          >
            <Link
              className="mx-3"
              to={`/`}
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "white",
                fontWeight: "700",
              }}
            >
              <img
                src="assetsfront/images/tlogo.png"
                style={{
                  width: "12%",
                  background: "white",
                  borderRadius: "197px",
                }}
                alt="Footer Logo"
              />
              &nbsp; TOPFACULTY
              {/* Login Profile */}
            </Link>
          </Typography>

          {/* Desktop View Nav */}
          <Box sx={{ display: { xs: "none", sm: "block" }, width: "90%" }}>
            {navItems.map((item) =>
              item !== "Counsellors" ? (
                <Button
                  key={item}
                  component={Link}
                  to={routeMap[item]}
                  sx={{ color: "#fff", fontWeight: "700" }}
                >
                  {iconMap[item] &&
                    React.createElement(iconMap[item], {
                      sx: { fontSize: 23, marginRight: 1 },
                    })}
                  {item}
                </Button>
              ) : (
                <Box
                  key="Counsellors"
                  sx={{
                    display: "inline-block",
                    position: "relative",
                    "&:hover .dropdown": {
                      opacity: 1,
                      visibility: "visible",
                      transform: "translateY(0)",
                    },
                  }}
                >
                  <Button
                    sx={{
                      backgroundColor: "#007bff",
                      color: "#fff",
                      fontWeight: "700",
                      textTransform: "none",
                      "&:hover": {
                        backgroundColor: "#42a5f5",
                      },
                    }}
                    endIcon={React.createElement(iconMap["Counsellors"], {
                      sx: { fontSize: 23, marginLeft: 1 },
                    })}
                  >
                    Counsellors
                  </Button>

                  <Box
                    className="dropdown"
                    sx={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      backgroundColor: "#fff",
                      minWidth: 200,
                      zIndex: 10,
                      boxShadow: 3,
                      borderRadius: 2,
                      mt: 1,
                      overflow: "hidden",
                      opacity: 0,
                      visibility: "hidden",
                      transform: "translateY(10px)",
                      transition: "all 0.3s ease-in-out",
                    }}
                  >
                    <Link
                      to="https://vgigroup.co.in/counseller.php"
                      style={{
                        padding: "12px 16px",
                        display: "block",
                        textDecoration: "none",
                        color: "#002147",
                        fontWeight: 600,
                        transition: "background 0.3s",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background = "#e3f2fd")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "transparent")
                      }
                    >
                      Counsellor List
                    </Link>

                    <Link
                      target="_blank"
                      to="https://topfaculty.co.in/c_pannel"
                      style={{
                        padding: "12px 16px",
                        display: "block",
                        textDecoration: "none",
                        color: "#002147",
                        fontWeight: 600,
                        transition: "background 0.3s",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background = "#e3f2fd")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "transparent")
                      }
                    >
                      Counsellor Login
                    </Link>
                  </Box>
                </Box>
              )
            )}

            {/* ✅ LOGIN BUTTON (ALWAYS LAST) */}

            {!user ? (<span> 
              <Button
              component={Link}
              to="/studentlogin"
              sx={{
                ml: 2,
                backgroundColor: "#ff9800",
                color: "#fff",
                fontWeight: "700",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "wheat",
                },
              }}
            >
              Student Login
            </Button>
            </span>) : ("")}
            
          </Box>

          {/* <Box sx={{ display: { xs: "none", sm: "block" } }} style={{width: "90%"}}>
            {navItems.map((item) => (
              <Button
                className="  "
                key={item}
                component={Link}
                to={routeMap[item]}
                sx={{ color: "#fff", fontWeight: "700" }}
              >
                {iconMap[item] &&
                  React.createElement(iconMap[item], {
                    sx: { fontSize: 23, marginRight: 1 },
                  })}
                {item}
              </Button>
            ))}

 
          </Box> */}
          <div className="user-info">
            {user ? (
              <>
                <div className="container py-2 ">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-12">
                      <ul className="list-unstyled">
                        <li className="dropdown ml-2">
                          <a
                            className="rounded-circle "
                            role="button"
                            id="dropdownUser"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <div className="avatar avatar-md avatar-indicators avatar-online">
                              <img
                                alt="avatar"
                                src="https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?ga=GA1.1.1808666041.1747736778&semt=ais_hybrid&w=740"
                                className="rounded-circle"
                              />
                            </div>
                          </a>
                          <div
                            className="dropdown-menu pb-2"
                            style={{ right: "0" }}
                            aria-labelledby="dropdownUser"
                          >
                            <div style={{ padding: "0px 1px 0px 25px" }}>
                              <div className="d-flex py-2">
                                {/* <div className="avatar avatar-md ">
                                  <img
                                    alt="avatar"
                                    src="https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?ga=GA1.1.1808666041.1747736778&semt=ais_hybrid&w=740"
                                    className="rounded-circle"
                                  />
                                </div> */}
                                <div className="ml-3 lh-1">
                                  <h5 className="mb-0 p-1">
                                    {" "}
                                    <strong>
                                      Welcome,{" "}
                                      <span className="info-color">
                                        {user.user_name}
                                      </span>{" "}
                                      <hr />
                                    </strong>
                                  </h5>

                                  {/* <strong className="mb-0 p-1">
                                    {user.user_email}
                                  </strong> */}

                                  <div
                                    className=" "
                                    style={{ lineHeight: "26px" }}
                                  >
                                    <ul>
                                      {/* <li>
                                        {" "}
                                        <Link
                                          to=""
                                          style={{ color: "rgb(13 52 188)" }}
                                        >
                                          {" "}
                                          <i
                                            class="fa fa-user"
                                            aria-hidden="true"
                                          ></i>
                                          &nbsp; Profile
                                        </Link>
                                      </li> */}

                                      {/* <li>
                                        <button
                                          onClick={() =>
                                            setShowProfileModal(true)
                                          }
                                          style={{
                                            color: "rgb(13 52 188)",
                                            fontWeight: "800",
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <i
                                            className="fa fa-user"
                                            aria-hidden="true"
                                          ></i>
                                          &nbsp; Profile
                                        </button>
                                      </li> */}

                                       <li>
                                        <Link
                                          to={`../student-profile`}
                                          style={{ color: "rgb(13 52 188)" }}
                                        >
                                          <i
                                            class="fa fa-user"
                                            aria-hidden="true"
                                          ></i>
                                          &nbsp; Profile
                                        </Link>
                                      </li>

                                      <li>
                                        <Link
                                          to={`../my-orders`}
                                          style={{ color: "rgb(13 52 188)" }}
                                        >
                                          <i
                                            class="fa fa-shopping-cart"
                                            aria-hidden="true"
                                          ></i>
                                          &nbsp; Orders
                                        </Link>
                                      </li>
                                      <li>
                                        {" "}
                                        <Link
                                          to={`../my-orders`}
                                          style={{ color: "rgb(13 52 188)" }}
                                        >
                                          {" "}
                                          <i
                                            class="fa fa-user"
                                            aria-hidden="true"
                                          ></i>
                                          &nbsp; My Course
                                        </Link>
                                      </li>
                                      <li style={{ color: "rgb(13 52 188)" }}>
                                        <Logout />
                                      </li>
                                    </ul>
                                  </div>
                                  {/* <h6 className="mb-0">
                                    
                                    <strong>
                                       <Logout />
                                    </strong>
                                  </h6> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <span> </span>
            )}
          </div>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}

          {/* ✅ LOGIN BUTTON (ALWAYS LAST) */}
          <Button
            component={Link}
            to="/studentlogin"
            sx={{
              ml: 0,
              backgroundColor: "#ff9800",
              color: "#fff",
              fontWeight: "700",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "wheat",
              },
            }}
          >
            Student Login
          </Button>
        </Drawer>
      </nav>
      {showProfileModal && (
        <div className="profile-modal-overlay">
          <div className="profile-modal">
            <button
              className="close-btn"
              onClick={() => setShowProfileModal(false)}
            >
              &times;
            </button>
            <h4>👤 Your Profile</h4>
            <div className="profile-content">
              <div className="carddesign">
                <div className="lines" />
                <div className="imgBx">
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQWmK6fb3-z8i2I0ORBbwwwkvHKTMw7JxXyZ_nNPDoh8OH_xu-PSTLzwpoIkBBsxXqmmQ&usqp=CAU"
                    alt="profile"
                  />
                </div>
                <div className="content">
                  {studentData.length > 0 ? (
                    studentData.map((item, index) => (
                      <div className="details" key={index}>
                        <h4 style={{ textAlign: "center" }}>
                          {item.name}
                          <br />
                          <span>{item.email}</span>
                        </h4>

                        <div className="data">
                          <h3>
                            Father: <span>{item.fname}</span>
                          </h3>
                          <h3>
                            Address: <span>{item.address}</span>
                          </h3>
                          <h3>
                            State/City:{" "}
                            <span>
                              {item.state}/{item.city}
                            </span>
                          </h3>
                        </div>

                        <div className="social-icons">
                          <a className="adds" href={`tel:${item.phone}`}>
                            <img
                              src="assetsfront/images/phon.png"
                              alt="Phone"
                              style={{
                                width: "32px",
                                height: "34px",
                              }}
                            />
                          </a>
                          <a className="adds" href={`mailto:${item.email}`}>
                            <img
                              src="assetsfront/images/email.jpg"
                              alt="Email"
                              style={{
                                width: "32px",
                                height: "34px",
                                borderRadius: "50%",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No student data found.</p>
                  )}
                </div>
              </div>

              {/* <p><strong>Name:</strong> John Doe</p>
              <p><strong>Email:</strong> john@example.com</p>
              <p><strong>Phone:</strong> +91-9876543210</p> */}
            </div>
          </div>
        </div>
      )}
    </Box>
  );
}

export default Header;
